import {CoordinateSystem} from '../enums/CoordinateSystem'
import {Geometry} from '../models'
import Axios from 'axios'

enum CS {
  GEO = 1,
  WEB = 2,
  BG2005 = 4,
  BG2005CAD = 5,
  BG703 = 6,
  BG705 = 7,
  BG707 = 8,
  BG709 = 9,
  BG50324 = 10,
  BG50327 = 11,
  BG50621 = 12,
  BG50627 = 13,
  BG3024 = 14,
  BG3027 = 15
}
export class BgTransService {
  serviceUrl: string
  constructor(serviceUrl: string) {
    this.serviceUrl = serviceUrl
  }
  getZone70(cs: CoordinateSystem): number {
    switch (cs) {
      case CoordinateSystem.BG_703:
        return 3
      case CoordinateSystem.BG_705:
        return 5
      case CoordinateSystem.BG_707:
        return 7
      default:
        return 9
    }
  }

  getCS(cs: CoordinateSystem): number {
    switch (cs) {
      case CoordinateSystem.BG_703:
        return CS.BG703
      case CoordinateSystem.BG_705:
        return CS.BG705
      case CoordinateSystem.BG_707:
        return CS.BG707
      case CoordinateSystem.BG_709:
        return CS.BG709
      case CoordinateSystem.GEOGRAPHIC:
        return CS.GEO
      case CoordinateSystem.BGS2005:
        return CS.BG2005
      case CoordinateSystem.BG2005CAD:
        return CS.BG2005CAD
      case CoordinateSystem.BG_3024:
        return CS.BG3024
      case CoordinateSystem.BG_3027:
        return CS.BG3027
      case CoordinateSystem.BG50324:
        return CS.BG50324
      case CoordinateSystem.BG50327:
        return CS.BG50327
      case CoordinateSystem.BG50621:
        return CS.BG50621
      case CoordinateSystem.BG50627:
        return CS.BG50627
      default:
        return CS.WEB
    }
  }

  bgTrans(destination: CoordinateSystem, geometry: Geometry): Promise<Geometry> {
    return new Promise<Geometry>((resolve, reject) => {
      const sourceIsBg =
        geometry.cs == CoordinateSystem.BG_703 ||
        geometry.cs == CoordinateSystem.BG_705 ||
        geometry.cs == CoordinateSystem.BG_707 ||
        geometry.cs == CoordinateSystem.BG_709 ||
        geometry.cs == CoordinateSystem.BG2005CAD ||
        geometry.cs == CoordinateSystem.BGS2005 ||
        geometry.cs == CoordinateSystem.BG_3024 ||
        geometry.cs == CoordinateSystem.BG_3027 ||
        geometry.cs == CoordinateSystem.BG50324 ||
        geometry.cs == CoordinateSystem.BG50327 ||
        geometry.cs == CoordinateSystem.BG50621 ||
        geometry.cs == CoordinateSystem.BG50627

      const destinationIsBg =
        destination == CoordinateSystem.BG_703 ||
        destination == CoordinateSystem.BG_705 ||
        destination == CoordinateSystem.BG_707 ||
        destination == CoordinateSystem.BG_709 ||
        destination == CoordinateSystem.BG2005CAD ||
        destination == CoordinateSystem.BGS2005 ||
        destination == CoordinateSystem.BG_3024 ||
        destination == CoordinateSystem.BG_3027 ||
        destination == CoordinateSystem.BG50324 ||
        destination == CoordinateSystem.BG50327 ||
        destination == CoordinateSystem.BG50621 ||
        destination == CoordinateSystem.BG50627

      const geomCoordinates = [...geometry.getCoordinates()]

      if (geometry.cs == destination) {
        resolve(geometry)
      } else if (sourceIsBg) {
        Axios.post(this.serviceUrl + '/Trans' + geometry.getType() + 's', {
          Coordinates: [geomCoordinates],
          DestinationZone: this.getZone70(geometry.cs),
          SourceCS: this.getCS(geometry.cs),
          DestinationCS: this.getCS(CoordinateSystem.WEB_MERCATOR)
        })
          .then(r => {
            geometry = geometry.clone()
            ;(geometry as any).setCoordinates(r.data[0])
            geometry.cs = CoordinateSystem.WEB_MERCATOR
            if (destinationIsBg) {
              resolve(this.bgTrans(destination, geometry))
            } else {
              resolve(geometry.trans(destination))
            }
          })
          .catch(e => {
            resolve(geometry)
          })
      } else if (destinationIsBg) {
        Axios.post(this.serviceUrl + '/Trans' + geometry.getType() + 's', {
          Coordinates: [geomCoordinates],
          DestinationZone: this.getZone70(destination),
          SourceCS: this.getCS(geometry.cs),
          DestinationCS: this.getCS(destination)
        })
          .then(r => {
            geometry = geometry.clone()
            ;(geometry as any).setCoordinates(r.data[0])
            geometry.cs = destination
            resolve(geometry)
          })
          .catch(e => {
            resolve(geometry)
          })
      } else {
        resolve(geometry.trans(destination))
      }
    })
  }
}
